import React from 'react';
import Traductor from '../../../Traductor';

import FormHeader from '../../common/FormHeader';
import TextInput from '../../common/TextInput';
import RadioInput from '../../common/RadioInput';

const CreateTicketRequestForm = ({ values, onChange, errors, touched }) => {
    const t = new Traductor();

    return (
        <section className="c-form-section  js-form-section  js-is-fx">
            <FormHeader text={t.getTraduction('TicketRequestData')} expanded />
            <div
                className="c-form-section__panel  js-form-section__panel"
                aria-hidden="false"
            >
                <div className="c-form-section__content">
                    <div className="o-fieldset__row">
                        <div className="o-layout__item u-1/4 u-1/2@m">
                            {/*USERNAME*/}
                            <TextInput
                                label={t.getTraduction('PlaceHolderUser')}
                                name="name"
                                values={values}
                                onChange={onChange}
                                errors={errors}
                                touched={touched}
                                row
                                readOnly
                                buscador={false}
                            />
                        </div>
                        <div className="o-layout__item u-1/4 u-1/2@m">
                            {/*PHONE */}
                            <TextInput
                                label={t.getTraduction('PlaceHolderPhone')}
                                name="phone"
                                values={values}
                                onChange={onChange}
                                errors={errors}
                                touched={touched}
                                row
                                type="tel"
                                buscador={false}
                            />
                        </div>

                        <div className="o-layout__item u-1/4 u-1/2@m">
                            {/*EMAIL */}
                            <TextInput
                                label={t.getTraduction('PlaceHolderEmail')}
                                name="email"
                                values={values}
                                onChange={onChange}
                                errors={errors}
                                touched={touched}
                                row
                                readOnly
                                buscador={false}
                            />
                        </div>
                        <div className="o-layout__item u-1/4 u-1/2@m">
                            {/* FINAL CLIENT */}
                            <RadioInput
                                label={t.getTraduction(
                                    'FinalClientPlaceholder'
                                )}
                                values={values}
                                onChange={onChange}
                                name="finalClient"
                                options={[
                                    {
                                        value: true,
                                        label: t.getTraduction('Si'),
                                    },
                                    {
                                        value: false,
                                        label: t.getTraduction('No'),
                                    },
                                ]}
                                errors={errors}
                                touched={touched}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CreateTicketRequestForm;
